import axios from "axios";
import { ENVIRONMENT_TYPE } from "../../constant/common";
import { ENDPOINT, environment } from "../../constant/environment";
import { toastMessage } from "../../utils/ToastProvider";
import { decryptData, encryptData, getHeaderConfig } from "../../utils/api/encryption";
import { consoleLog } from "../../utils/consoleLog/consoleLog";
import { Messages } from "../../constant/messages/toastMessages";
import { hasUsableJWT } from "../../utils/authentication/hasUsableJWT";

export const ERR_NETWORK = "ERR_NETWORK";

export async function chatInteractionAPI(
  accessJWT: string,
  userId: string,
  userInput: string,
  messages: any[],
  signal?: AbortSignal,
  iteneryInput?: any,
  appConfig?: any
) {
  const URL = `${ENDPOINT}/app/v1/itineraries/search`;
  let config = getHeaderConfig(signal, accessJWT);
  let body = {
    userId,
    userInput,
    messages,
    iteneryInput,
  };
  if (!hasUsableJWT(accessJWT, "chatInteractionAPI")) return null;
  try {
    consoleLog(["chatInteractionAPI Payload", body, accessJWT]);
    const response = await axios.post(URL, encryptData(body), config);
    const decryptedData = decryptData(response?.data);
    consoleLog(["RESPONSE From chatInteractionAPI", JSON.parse(decryptedData)]);
    return decryptedData ? JSON.parse(decryptedData) : null;
  } catch (error: any) {
    if (error?.code !== "ERR_CANCELED" && environment !== ENVIRONMENT_TYPE.PRODUCTION)
      toastMessage.error(Messages["api.break.down"].messageTitle, Messages["api.break.down"].message);
    consoleLog(["RESPONSE CHAT ERROR", error]);
    return error?.code || ERR_NETWORK;
  }
}
